import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Slider } from "react-burgers";
import cx from 'classnames';
import { faEllipsisV, } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import { setEnableMobileMenu, setEnableMobileMenuSmall } from '../../reducers/ThemeOptions';
import { useDispatch } from 'react-redux';
import { setMenuMainShow } from "../../reducers/models/menuData";
import { useSelector } from 'react-redux';
import AppMobileMenu from '../AppMobileMenu';

function Index() {

    const dispatch = useDispatch()
    const stateMenu = useSelector((state) => state.menuData);//Настройки приложения
    const stateSize = useSelector((state) => state.size);//Настройки приложения

    return (
        <Fragment>
            {stateSize.windowWidth > 991 ? (
                <div className="app-header__logo" >
                    {stateMenu.menuMainShow === true && (
                        <div className='text-white fw-bold fs-5'>BIZ-Трекер</div>
                    )}
                    <div className="header__pane ms-auto">
                        <div>
                            <Slider
                                active={stateMenu.menuMainShow}
                                type="elastic"
                                onClick={() => { dispatch(setMenuMainShow({ data: !stateMenu.menuMainShow })); }}
                            />
                        </div>
                    </div>


                </div>
            ) :
                (
                    <div className="app-header__logo" style={{ display: 'flex', width: '150px' }}>
                        {stateMenu.menuMainShow === true && (
                            <div className='text-white fw-bold fs-5'>BIZ-Трекер</div>
                        )}

                        {stateMenu.menuMainMobileShow === true && (
                            <div className="header__pane ms-auto">
                                <div>
                                    <Slider
                                        active={stateMenu.menuMainShow}
                                        type="elastic"
                                        onClick={() => { dispatch(setMenuMainShow({ data: !stateMenu.menuMainShow })); }}
                                    />
                                </div>
                            </div>
                        )}

                    </div>
                )

            }

            <AppMobileMenu />
        </Fragment>
    )
}

export default Index;